module.exports = "/_next/static/images/vegetables-9eb3505192fe62dac55e5615854924be.jpg";